import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { getLocationManagementModuleName } from './location-management.permissions';

export class CitiesPermissions {
    static GroupName = `${getLocationManagementModuleName()}.Cities`;

    static getPermissions = getGroupPermissionFactory(CitiesPermissions.GroupName);

    static Permissions = {
        Create: CitiesPermissions.getPermissions(PermissionEnum.CREATE),
        Read: CitiesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: CitiesPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: CitiesPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
